/**
 * 成功時のバイブレーション。Vibration APIに対応していない端末では何もしない。
 */
export const vibrateSuccess = () => {
  try {
    if (typeof navigator === "undefined" || !navigator.vibrate) return;
    navigator.vibrate([80, 40, 80]);
  } catch {
    // バイブレーション失敗時は無視
  }
};

/**
 * 失敗時のバイブレーション。成功時と区別できるよう、長めの振動を繰り返すパターン。
 */
export const vibrateError = () => {
  try {
    if (typeof navigator === "undefined" || !navigator.vibrate) return;
    navigator.vibrate([200, 100, 200, 100, 200]);
  } catch {
    // バイブレーション失敗時は無視
  }
};
